<template>
    <span 
        class="status__map text--xs tag bold" 
        :class="[customStatus ? customStatusClass : statusText, !isTable ? 'badge rounded-pill' : '' ]"
        v-bind="{...$attrs }"
    >
        <template v-if="isTable">
            <span class="status__circle" :class="[`${statusText}__text`]" />
        </template>
        <template v-if="isIcon">
            <IconSvg :name="currentStatus.iconName" width="16px" class="mr--5" />
        </template>

        {{ textValue }}
    </span>
</template>

<script>
import { 
    projectStatusMap, 
    projectTypeMap,
    invoiceStatusMap,
    clientStatusMap,
    meetingStatusMap,
    paymentStatusMap,
    projectDeadlineCopyMap,
} from "@/utils/enums";
import IconSvg from "../icons/Icon-Svg.vue";

export default {
    name: "Status",

    components: { IconSvg },

    props: {
        isIcon: {
            type: Boolean,
            default: false,
        },
        isTable: {
            type: Boolean,
            default: true,
        },
        customStatus: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: "",
        },
        type: {
            type: [String, undefined],
            default: "",
            validator: (value) => {
                return [
                    "client", 
                    "project", 
                    "invoice", 
                    "project_payment", 
                    "meeting",
                    "subscription_payments",
                    "project_deadline",
                    "",
                ].includes(value);
            },
        },
        customText: {
            type: String,
            default: "",
        },
        customStatusClass: {
            type: String,
            default: "",
        },
    },

    computed: {
        statusMap() {                        
            switch (this.type) {
            case "client":
                return clientStatusMap;
                
            case "project":
                return projectStatusMap;

            case "project_payment":
                return projectTypeMap;

            case "project_deadline":
                return projectDeadlineCopyMap;

            case "invoice":
                return invoiceStatusMap;

            case "meeting":
                return meetingStatusMap;

            case "subscription_payments":
                return paymentStatusMap;
            
            default:
                return null;
            }
        },

        currentStatus() {                                    
            return this.statusMap && this.value ? this.statusMap[this.value] : { tag: "", iconName: "" };
        },

        textValue() {
            if (this.customText) {
                return this.$capitalize_first_letter(this.customText) || "";
            }

            if (this.value) {
                return this.$capitalize_first_letter(this.value) || "";
            }

            return "";
        },

        statusText() {
            const key = this.textValue?.toLowerCase()?.trim();
            
            switch (key) {
            case "active":
            case "paid":
            case "completed":
            case "enabled":
            case "hourly":
            case "fully paid":
                return "tag--green";

            case "disabled":
            case "cancelled":
            case "weekly":
            case "pending":
            case "not paid":
            case "archived":
                return "tag--pink";

            case "one-off":
            case "potential lead":
            case "needsAction":
                return "tag--cornsilk";

            case "requires fixes":
            case "overdue":
            case "blocked":
            case "failed":
                return "tag--red";

            case "draft":
            case "in progress":
            case "onboarding":
            case "none":
            case "yearly":
            case "due soon":
            case "confirmed":
                return "tag--blue";

            case "awaiting feedback":
            case "rejected":
            case "inactive":
                return "tag--grey";

            case "reached out":
            case "per-project":
            case "issued":
                return "tag--purple";
            
            case "partially paid":
            case "to do":
                return "tag--purple-2";
            
            default:
                return "tag--grey";
            }
        },
    },
};
</script>